import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  classWrapper: {
    display: 'flex',
    position: 'relative',
  },
  removeClassBtn: {
    textTransform: 'uppercase',
    left: '25rem',
    top: '4.7rem',
    paddingLeft: 0,
    position: 'absolute',
  },
  warningClassMessage: {
    textTransform: 'uppercase',
    left: '25rem',
    top: '3.7rem',
    position: 'absolute',
    color: colors.neutral[600],
    fontSize: '1.4rem',
  },
  classDefaultName: {
    '& div': {
      marginBottom: '1rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
